import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas, SectionContainer } from '../../styles';
import { RightRailDetails } from '../../types';

const createGridTemplateAreas = (details?: RightRailDetails) =>
    [
        GameCenterComponentGridAreas.playByPlay,
        window.__AD_SETTINGS__.mrecDivId ? GameCenterComponentGridAreas.ad : '',
        GameCenterComponentGridAreas.lineScore,
        details?.shotsByPeriod ? GameCenterComponentGridAreas.shotsOnGoal : '',
        GameCenterComponentGridAreas.gameStats,
        GameCenterComponentGridAreas.seasonSeries,
        GameCenterComponentGridAreas.gameInfoReports,
    ]
        .filter((item) => item)
        .map((item) => `'${item}'`)
        .join('\n');

export const PlayByPlayContainer = styled(SectionContainer)<{ $details?: RightRailDetails }>`
    grid-template-areas: ${({ $details }) => createGridTemplateAreas($details)};

    ${BaseStyle.Mixins.screenSizes.large} {
        grid-template-areas: '${GameCenterComponentGridAreas.playByPlay} ${GameCenterComponentGridAreas.rightRail}';
    }
`;
